import React, { useState } from "react";
import YoutubeTutorial from "Components/common/YoutubeTutorial";
import ConfigureButton from "../ConfigureButton";
import InstallButton from "../InstallButton";

const PipedriveAction = props => {
  const {
    pipedriveConnected = true,
    data: { youtubeLink = "" },
    toolTipPopup,
    pipedriveConfigureCbk = () => {},
    isFeatureEnabled = false
  } = props;
  const [showVideo, setVideo] = useState(false);

  const closeVideo = () => {
    setVideo(false);
  };

  return !isFeatureEnabled ? (
    <InstallButton {...props} />
  ) : pipedriveConnected ? (
    <div className="buttonCont wrapConnectedBtn">
      <div
        className={`connectedBtnCont btn ${isFeatureEnabled ? "" : "disabled"}`}
        onClick={pipedriveConfigureCbk}
      >
        <i className="material-icons-outlined">settings</i>
        Configure
      </div>
      {showVideo && (
        <YoutubeTutorial videoId={youtubeLink} closeCbk={closeVideo} />
      )}
    </div>
  ) : (
    <div className="buttonCont">
      <ConfigureButton
        toolTipPopup={toolTipPopup}
        value={"Configure"}
        configureCbk={pipedriveConfigureCbk}
        isFeatureEnabled={isFeatureEnabled}
      />
    </div>
  );
};

export default PipedriveAction;
export { PipedriveAction };
